import Layout from '@/views/Layout'

const storeRoutes = {
    path: '/store',
    component: Layout,
    name: 'Store',
    meta: {
        title: '门店管理',
        icon: 'Shop'
    },
    children: [
        {
            path: 'list',
            name: 'StoreList',
            component: () => import('@/views/Store/store/store_list/store_list.vue'),
            meta: {
                title: '门店列表',
                keepAlive: true
            }
        },
        {
            path: 'layout',
            name: 'StoreLayout',
            component: () => import('@/views/Store/store/layout/index.vue'),
            meta: {
                title: '门店布局图',
                hidden: true,
                keepAlive: true,
                parentPath: '/store/list',
                parentName: '门店列表'
            }
        }
    ]
}

export default storeRoutes; 